import { useLocation } from 'react-router'

type QueryParams = {
  [key: string]: string | null
}

export function useQueryParams<T extends QueryParams>(): Partial<T> {
  const querySearchParams = new URLSearchParams(useLocation().search)
  if (!querySearchParams) {
    return {}
  }

  const params: Record<string, unknown> = {}

  for (const [key, value] of querySearchParams) {
    params[key] = value
  }
  return params as Partial<T>
}
